import { Component, EventEmitter, Input, Output } from "@angular/core";
import { PlanCard } from "./plan-card.model";
import { properties } from "src/environments/properties";

@Component({
  selector: "app-plan-card",
  templateUrl: "./plan-card.component.html",
  styleUrls: ["./plan-card.component.scss"],
})
export class PlanCardComponent {

  properties = properties;

  enableForUPlus: boolean = this.properties.featureFlags.enableForUPlus;
  programDisplayData = this.enableForUPlus ? this.properties.programType.forUPlus : this.properties.programType.freshpass;

  @Input() planCard: PlanCard;
  @Input() cardType?: string | null = null;
  @Output() actionChange = new EventEmitter<void>();

  emitActionChange() {
    this.actionChange.emit();
    if (window['AB'] && window['AB']['DATALAYER'] && !window.location.pathname.startsWith(this.programDisplayData?.urlPath?.SUBSCRIBE_PATH)) {
      const subObj = {
        campaignType: this.planCard?.details?.campaignType,
        planCardTitle: this.planCard?.title,
      };
      window['AB']['DATALAYER'].updateAnalyticsSubscriptionInfo('change', subObj);
      window['AB']['DATALAYER'].analyticsSetLSFPUpdate(this.planCard?.title?.includes('annual') ? 'changePlanToAnnualBtn' : 'changePlanToMonthlyBtn');
    }
  }
}
